import * as THREE from 'three'
import { DataManager, type ICADMetadata } from './module/CADModule/manager/DataManager'
import { ObjectManager } from './module/CADModule/manager/ObjectManager'
import type { CadLoadResult } from './types'

export {
  createDefaultCadPlaneMetadata,
  normalizeJsonCadMetadata,
} from './normalizeJsonCadMetadata'

/**
 * 将 CAD 元数据反序列化为可直接挂载的加载结果，构建数据管理器、对象管理器与场景 Group。
 *
 * @param data - 原始元数据；缺省得到空白图纸
 * @param metadataOverrides - 覆盖返回结果中 metadata 字段的部分数据
 * @returns CAD 加载结果，包含管理器、实体与场景 Group
 */
export function createCadLoadResultFromMetadata(
  data?: ICADMetadata,
  metadataOverrides?: Partial<CadLoadResult['metadata']>
): CadLoadResult {
  const dataManager = DataManager.deserialize(data)
  const objectManager = new ObjectManager()
  const entities = dataManager.entities

  objectManager.addEntities(entities)
  objectManager.updateGroupByPlane(dataManager.plane)

  return {
    metadata: {
      boundingBox: metadataOverrides?.boundingBox ?? new THREE.Box3(),
      layerCount: metadataOverrides?.layerCount ?? dataManager.layers.length,
    },
    scene: objectManager.getSceneGroup(),
    entities,
    dataManager,
    objectManager,
  }
}
